<ion-icon icon="git-branch" [color]="color ? color : 'light'"></ion-icon>